<div class="ui selection dropdown multiple" uiDropdown="click">
  @for (value of selectedValue; track value) {
    <a class="ui label transition visible">{{value}}
      <i class="delete icon" (click)="deleteValueFromSelected(value)"></i>
    </a>
  }
  <i class="dropdown icon"></i>
  <div class="default text">{{hint}}</div>
  <div class="menu">
    @for (item of selectList; track item; let i = $index) {
      <div class="item"
      (click)="onSelectValue(i)" [ngClass]="{'active filtered': selected[i]}">{{item}}</div>
    }
  </div>
</div>
